var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"scroll-hint-arrow center-absolute fadeable",staticStyle:{"margin-top":"16px"},style:({
      opacity: _vm.upArrowOpacity+' !important'
    }),on:{"click":_vm.scrollUp}},[_c('DownArrowSVG',{staticClass:"center-absolute",staticStyle:{"transform":"rotate3d(0, 0, 1, 180deg)"}})],1),_c('div',{staticClass:"scroll-hint-arrow center-absolute fadeable",staticStyle:{"margin-bottom":"16px"},style:({
      opacity: _vm.downArrowOpacity+' !important'
    }),on:{"click":_vm.scrollDown}},[_c('DownArrowSVG',{staticClass:"center-absolute"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }